import { render } from "./Checkups.vue?vue&type=template&id=f4454bd2&scoped=true"
import script from "./Checkups.vue?vue&type=script&lang=js"
export * from "./Checkups.vue?vue&type=script&lang=js"

import "./Checkups.vue?vue&type=style&index=0&id=f4454bd2&scoped=true&lang=scss"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4454bd2"]])

export default __exports__